const RTB_ROLES = {
    buyer: {
        id: 1,
        name: 'Buyer',
    },
    reseller: {
        id: 2,
        name: 'Reseller',
        tippyMessage: 'Reseller mode is unavailable because "Standard" routing is selected. Please select "Revenue" routing to use RTB as a Reseller',
    },
}

export {
    RTB_ROLES,
}
